import React, { Component } from 'react';
import { connect } from 'react-redux';
import TopMenu from './Menu/TopMenu.jsx';
import SideMenu from './Menu/SideMenu.jsx';
import {withRouter} from 'react-router'
import { NavLink, Link } from 'react-router-dom';
import qs from 'qs';
import axios from 'axios';
import fetchMe from '../actions/fetchMe';
import setOpenMobileMenu from '../actions/setOpenMobileMenu';
import GeneralWrapper from './Wrappers/General.jsx';
import { inject, observer } from 'mobx-react'

class MobileWrapper extends Component {
  constructor(props) {
    super(props);
    this.state={
      show_mobile:false,
      overlay_class:'dn op0'
    };
  }
  componentDidUpdate(oldProps,oldState) {
    if(oldState.show_mobile!==this.state.show_mobile) {
      if(this.state.show_mobile) {
        setTimeout(()=>{
          this.setState({overlay_class:'op0'});
        },10);
        setTimeout(()=>{
          this.setState({overlay_class:'op100'});
        },40);
      } else {
        setTimeout(()=>{
          this.setState({overlay_class:'op0'});
        },10);
        setTimeout(()=>{
          this.setState({overlay_class:'op0 dn'});
        },300);
      }
    }
  }
  renderMobileMenu() {
    return this.props.menu.top.map((item)=>{
      return (
        <NavLink key={item.route} exact={item.route=='/'?true:false} className="db clear tdni w1 vpadd5 hpadd20" to={item.route} activeClassName="bg-b2">
          {item.name}
        </NavLink>
      )
    })
  }
  componentWillReceiveProps(nextProps) {
    if(this.state.show_mobile && nextProps.router.location.key!=this.props.router.location.key) {
      this.setState({ show_mobile:false });
    }
  }
  getAuthUrl() {
    let parsed=qs.parse(this.props.router.location.search,{ ignoreQueryPrefix:true });
    parsed.popup=`/user/auth`;
    const string=qs.stringify(parsed);
    return `${this.props.router.location.pathname}?${string}`;
  }
  getRegistrerUrl() {
    let parsed=qs.parse(this.props.router.location.search,{ ignoreQueryPrefix:true });
    parsed.popup=`/user/register`;
    const string=qs.stringify(parsed);
    return `${this.props.router.location.pathname}?${string}`;

  }
  logOut() {
    axios.get('/api/user/logout').then((item)=>{
      if(item.data.answer===true) {
        this.props.fetchMe();
      }
    });
  }
  renderAuthedMenu() {
    return (
      <div className="pbottom30">
        <span onClick={()=>{ this.logOut(); }} className="db pointer clear tdni w1 vpadd5 hpadd20">
          Log Out
        </span>
      </div>
    )
  }
  getMenuType() {
    const ex=this.props.router.location.pathname.split('/');
    return ex[1];
  }
  renderGuestMenu() {
    return (
      <div className="pbottom30">
        <Link className="db pointer clear tdni w1 vpadd5 hpadd20" to={this.getRegistrerUrl()}>
          Register
        </Link>
        <Link className="db pointer clear tdni w1 vpadd5 hpadd20" to={this.getAuthUrl()}>
          Auth
        </Link>
      </div>
    )
  }
  render() {
    return (
      <div className="pr  m-pbottom30"  style={{minHeight:'0'}}>
        <div className={`pa pa tl w100 h100 bg-b1-op20 menuOverlay trans03 ${this.props.mobile_menu_open?'opened':''}`} onClick={()=>{ this.props.setOpenMobileMenu(false); }} style={{zIndex:900}}></div>
        <div className="up12 splice">
          <div className="cell s-shrink">
            <SideMenu opened={false} />
          </div>
          <div className="cell s-auto">
            <GeneralWrapper menuType={this.getMenuType()}>
              {this.props.children}
            </GeneralWrapper>
          </div>
        </div>

      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    menu:state.menu,
    router:state.router,
    me:state.me,
    mobile_menu_open:state.mobile_menu_open,
  }
}

export default inject("meStore","router")(observer(MobileWrapper));
// export default withRouter(connect(mapStateToProps,{ fetchMe,setOpenMobileMenu })(MobileWrapper))
//export default withRouter(MobileWrapper);